import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EducationRoutingModule } from './education-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    EducationRoutingModule
  ]
})
export class EducationModule { }
